import { render } from "./catalogArticleDetail.vue?vue&type=template&id=6e6b24dd&scoped=true"
import script from "./catalogArticleDetail.vue?vue&type=script&lang=js"
export * from "./catalogArticleDetail.vue?vue&type=script&lang=js"

import "./catalogArticleDetail.vue?vue&type=style&index=0&id=6e6b24dd&lang=scss&scoped=true"
import "./catalogArticleDetail.vue?vue&type=style&index=1&id=6e6b24dd&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6b24dd"]])

export default __exports__